import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {ANSWER} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('answers.title'),
                url: ANSWER,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('question'),
                        type: 'custom-html',
                        key: 'question',
                        isVisible: true,
                        modifier: (question) => {
                            return question ? question.question_text ? question.question_text : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('answers.answer_text'),
                        type: 'text',
                        key: 'answer_text',
                        isVisible: true,
                    },
                    {
                        title: this.$t('answers.is_correct'),
                        type: 'text',
                        key: 'is_correct',
                        isVisible: true,
                    },
                    {
                        title: this.$t('attachments'),
                        type: 'component',
                        componentName: 'app-attachments-column',
                        key: 'attachments',
                        modifier: (h, params) => {
                            const files = params.row.attachments ? params.row.attachments.filter(file => isImage(file.full_url)) : [];
                            return h('app-attachments-column', {
                                props: {
                                    attachments: files, // Only image files will be passed
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-answer-modal',
                        modalId: 'answer-modal',
                        url: ANSWER,
                        name: 'edit',
                        modifier: row => this.$can('update_answer')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'answer-modal',
                        url: ANSWER,
                        name: 'delete',
                        modifier: row => this.$can('delete_answer')
                    },
                ],
            }
        }
    }
}
export function isImage(url) {
    return /\.(jpeg|jpg|gif|png|svg|webp)$/i.test(url);
}
